define('services/timeRangeSettingsService',[
    'lib/lodash4',
    'lib/bluebird',
	'services/userService',
	'services/userSettingsService'
], function(
    _,
    Promise,
	userService,
	userSettingsService
) {
    'use strict';

    var PREFIX_NAMESPACE    = "timeRange";
    var DEFAULT_ENTITY   = "OBJECT_ENTITY";


    var getKey = function(entityId, namespace){
        var key = namespace || DEFAULT_ENTITY;

        return  PREFIX_NAMESPACE + "." + key + "." + entityId;
    };

    var timeRangeSettingsService = {

        getSettings: function (entityId, defaultSettings, namespace) {

            var key = getKey(entityId, namespace);

            if(userService.currentUser()) {
                defaultSettings = defaultSettings || {};

                return userSettingsService.getSettings()
                    .then(function(settings) {
                        return _.assign(defaultSettings, settings[key]);
                    });
            }

            return Promise.reject(new Error("Cannot load time range settings without currentUser()."));
        },

        setSettings: function (entityId, settings, namespace) {

            var key = getKey(entityId, namespace);

            if(userService.currentUser()) {
                var newSettings = {};
                newSettings[key] = settings;
                return userSettingsService.setSettings(newSettings);
            }

            return Promise.reject(new Error("Cannot save time range settings without currentUser()."));
        }
    };

    return timeRangeSettingsService;

});

